import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

function createData(name, calories) {
  return { name, calories };
}


export default function Invoice(props) {
  const { invoiceContent } = props

  const rows = [
    createData('مبلغ (ریال)', invoiceContent["payedPrice"]),
    createData('شماره سفارش', invoiceContent["orderId"]),
    createData('تاریخ خرید', new DateObject({
      date: invoiceContent["buyingDate"],
      calendar: persian,
      locale: persian_fa,
    }).format()),
    createData('تاریخ پایان پکیج', new DateObject({
      date: invoiceContent["endingDate"],
      calendar: persian,
      locale: persian_fa,
    }).format()),
  ];

  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>محصول</TableCell>
            <TableCell align="right">پکیج یادگیری زبان</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.calories}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
